export const CUSTOM_WATCHLIST_MESSAGES = {
  CREATED: 'Custom watchlist was successfully imported',
  CREATED_WITH_WARNING: 'All unique entries was successfully imported. Please check logs',

};


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/constants/customWatchlistMessages.js